import { render, staticRenderFns } from "./DataInputSlider.vue?vue&type=template&id=6673807e&scoped=true&"
import script from "./DataInputSlider.vue?vue&type=script&lang=js&"
export * from "./DataInputSlider.vue?vue&type=script&lang=js&"
import style0 from "./DataInputSlider.vue?vue&type=style&index=0&id=6673807e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6673807e",
  null
  
)

export default component.exports